var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',[_c('VuePlyr',{ref:"plyr",style:({
			height: _vm.height + 'px',
			width: _vm.width + 'px'
		}),attrs:{"options":_vm.options}},[_c('video',{ref:"video",attrs:{"autoplay":_vm.active ? true : null,"playsinline":true,"poster":_vm.livePhotoPath,"src":_vm.src,"preload":"metadata"},on:{"ended":_vm.donePlaying,"canplay":_vm.doneLoading,"loadedmetadata":_vm.onLoadedMetadata}},[_vm._v("\n\n\t\t\t"+_vm._s(_vm.t('viewer', 'Your browser does not support videos.'))+"\n\t\t")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }